import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import board from '../Assets/Artboard 1.png';
import bird from '../Assets/tree2.svg';
import program0 from '../Assets/test.png';
import program1 from '../Assets/program2.jpg';
import man from "../Assets/illustration-people-2.svg";
import path from "../Assets/path-1.svg";
import leaf from "../Assets/leaf-2.svg";
import leaf1 from "../Assets/leaf-1.svg";
import tree from "../Assets/tree2.svg";
import graduate from "../Assets/program.jpg"
import program2 from "../Assets/program2.jpg"
import snail from "../Assets/snail.svg";
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';
import Ages from '../UI/Ages';
import { Helmet } from 'react-helmet';

const Program = () => {
  const [scale, setScale] = useState(1); // State to manage scaling

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = Math.max(0.5, 1 - scrollY / 1000); // Adjust scaling
      setScale(newScale);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <ParallaxProvider>
      <Helmet>
        <title>Best Day Care | Play Group | Pre KG | LKG | UKG in Vellore</title>
        <meta name="description" content="Looking for the Best Day Care, Play Group, Pre KG, LKG & UKG in Vellore? Our Programs Support Early Learning, Care, and School Readiness." />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div>
        <div className="relative w-full">
          {/* Swiper Section */}
          <div className="relative">
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              autoplay={{
                delay: 3000, // Adjust the delay in milliseconds
                disableOnInteraction: false,
              }}
              loop={true}

            >
              {/* <SwiperSlide> */}
              <img src={program0} alt="Program 1" className=" md:object-cover object-fill w-full h-[490px] md:h-[400px] lg:h-[500px]" />
              {/* </SwiperSlide> */}
              {/* <SwiperSlide>
      <img src={program1} alt="Program 2" className="object-cover w-full h-[500px] md:h-[400px] lg:h-[450px]" />
    </SwiperSlide>
    <SwiperSlide>
      <img src={graduate} alt="Program 2" className="object-cover w-full h-[500px] md:h-[400px] lg:h-[450px]" />
    </SwiperSlide> */}
            </Swiper>

            {/* Board and Text Content */}
            <div className="relative">
              <img
                src={board}
                alt="Board"
                className="absolute -top-[430px] md:-top-[590px] lg:-top-[680px] h-[600px] md:h-[900px] lg:h-[1050px] w-[1080px] md:w-[900px] lg:w-[1050px] left-0"
                style={{ zIndex: 10 }}
              />

              {/* Text Content */}
              <div className="absolute z-40 -top-52 md:-top-60 lg:-top-72 left-[195px] md:left-[450px] lg:left-[540px] transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
                <Parallax translateY={[-100, 100]} className="mb-4">
                  <img src={bird} alt="Bird" className="w-24  md:w-36 h-36 lg:w-48  mt-0 md:mt-12" />
                </Parallax>
                <div className="text-[#0a3039] navbar-link mt-4 md:mt-36">
                  <h1 className="text-md md:text-3xl lg:text-[#16bab1]xl font-sans text-[#16bab1]enter  font-bold ">Choose from our</h1>
                  <h2 className="text-xl md:text-6xl lg:text-7xl text-[#16bab1]enter font-sans sensei-text font-bold">Programs</h2>
                  <h3 className="text-md md:text-[#16bab1]xl lg:text-3xl font-sans text-[#16bab1]enter font-bold">Starts now</h3>
                </div>
              </div>
            </div>

            {/* Wave Effect */}
            <div className="wave rotate-180 z-20 absolute inset-0 top-[390px] md:top-[250px] lg:top-[400px]"></div>
          </div>
        </div>
        <div className='text-[#0a3039] max-w-screen-xl mx-auto'>
          <div>

          </div>

          <div className='relative w-full mt-4'>
            <div className=' max-w-screen-md mx-auto'>
              {/* Left Section */}

              <Parallax translateX={[5, -5]} className='text-[220px] sensei-text '>
                <strong className="">Our</strong>
              </Parallax>

              {/* Right Section */}
              <div className='w-full pl-24 mb-5  px-4'>

                <h1 className='text-3xl md:text-5xl font-bold mb-4 navbar-link'>
                  promise to families.
                </h1>
                <p className='font-sans mb-4'>
                  At Skole, we know childhood is a treasured time. We believe it is our responsibility to provide environments and experiences that capture the joys of childhood, nurture each child’s individual growth and development, and pave the way for success in school and life.
                </p>
              </div>


              {/* Decorative Images */}
            </div>
            <div
              className=' mt-12'>
              <img src={leaf} alt="leaf" className='absolute -bottom-10 left-6 h-8 sm:h-10 md:h-16 lg:h-24' />
              <img src={leaf1} alt="leaf1" className='absolute -bottom-10 md:-bottom-24 left-20 sm:left-28 h-12 sm:h-16 md:h-24 lg:h-36' />
              <img src={tree} alt="tree" className='absolute -bottom-10 right-4 h-20 sm:h-28 md:h-36 lg:h-auto' />
              <img src={path} alt="path" className='rotate-0 md:-rotate-6 absolute w-full -mt-6 sm:-mt-8 md:-mt-12' />

            </div>

          </div>

        </div>
        <div className=' max-w-screen-md mx-auto  '>
          {/* Left Section */}
          <div className='text-[#0a3039]'>
            <Parallax translateX={[5, -5]} className='text-[220px] sensei-text '>
              <strong className="">The</strong>
            </Parallax>

            {/* Right Section */}
            <div className='w-full  pl-0  text-[#16bab1]enter md:pl-24 mb-5  px-4'>
              <h1 className='text-3xl md:text-5xl font-bold mb-4 navbar-link'>
                Kalam Kids Difference
              </h1>
              <p className='font-sans mb-4'>
                We offer a unique early education experience built on 30 years of expertise, and on what working families have told us they want and need for their children…and for themselves. Child care and early education isn’t just what we do – it’s who we are.
              </p>

            </div>
          </div>
          {/* Decorative Images */}

        </div>
        <Ages />
        <div className='wave  mt-12 '></div>
        <div className='bg-[#f4f1ea] navbar-link h-auto -mt-20 w-full'>
          <div className='flex flex-wrap justify-center items-center max-w-screen-xl mx-auto'>
            <div className='w-full lg:w-[50%]   mt-24 h-auto p-8'>
              <h1 className='text-[#0a3039] text-[40px] lg:text-[60px] font-semibold'>Investing in yor child's future.</h1>
              <p className='text-[#0a3039] text-base lg:text-xl w-full font-medium'>
                We know tuition is an investment. We’ve thoughtfully set our rates to balance the impact on families with the professional trainings, program development, equipment and resources, and competitive teacher compensation and benefits required for our standard of care.
              </p>

            </div>
            <div className='w-full lg:w-[50%] mt-24 lg:mt-24'>
              <img src={graduate} alt="graduate" className='w-full h-auto' />
            </div>
          </div>
          <div>
            <div className='flex flex-wrap justify-center items-center max-w-screen-xl mx-auto'>
              <div className="flex flex-wrap mt-24">
                {/* Image Section */}
                <div className="w-full lg:w-[50%] flex justify-center space-x-2 lg:justify-end">
                  <img src={program2} alt="Community" className="w-[300px] md:w-[400px] lg:w-[700px] h-[300px] md:h-[350px] my-8 lg:h-[400px] " />
                </div>

                {/* Text Section */}
                <div className="w-full lg:w-[50%]  h-auto p-8  -mt-4 ">
                  <h1 className="text-[#0a3039] text-[32px] md:text-[40px] lg:text-[60px] font-semibold mb-4">Health and Safety</h1>
                  <p className="text-[#0a3039] text-base md:text-lg lg:text-xl font-medium mb-4">
                    At Skole, we make your child’s health and safety our top priority. Our standards are the highest in the industry, meeting or exceeding all local and state guidelines.
                  </p>
                  <ul className="list-disc list-inside text-[#0a3039] text-sm md:text-base lg:text-lg font-medium space-y-2">
                    <li>Supervision to keep children within sight and sound</li>
                    <li>Secured entrances to all centers</li>
                    <li>Nightly cleaning of all surfaces, including toys, child furnishings   </li>
                    <li>Strict hand-washing and sanitary policies to prevent the spread of germs</li>
                    <li>Curriculum that emphasizes healthy practices for children</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='wave rotate-180 relative'>
              <Parallax translateX={[-25, 25]} className='absolute  right-96 top-2'>
                <img src={snail} alt="sanl" className=' rotate-180' />
              </Parallax>
            </div>
          </div>
        </div>
      </div>
    </ParallaxProvider>
  );
};

export default Program;
